import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { makeMainLayout } from '@/layouts/main'
import BoostAListing from '@/features/BoostListing/boost-a-listing'
import Head from '@/components/head'

const PostListingTour = () => {
  const { t } = useTranslation()

  const metaTitle = t('pricing:Sign Up & Get Started | liv.rent')
  const metaDescription = t(
    `pricing:Sign up for free and upgrade your plan. Start using liv.rent's landlord features today - tenant screening, digital application & contracts, instant chat & more.`
  )

  return (
    <>
      <Head
        title={metaTitle}
        description={metaDescription}
        path="/boost-a-listing"
      />
      <BoostAListing />
    </>
  )
}

export const getStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'pricing']))
    }
  }
}

const headerConfig = {
  visible: false
}

const footerConfig = {
  visible: false
}

PostListingTour.Layout = makeMainLayout({ headerConfig, footerConfig })

export default PostListingTour
